import { observer } from 'mobx-react-lite'
import { Avatar, Typography } from 'shared/ui'
import { Select } from 'shared/ui/Select/Select'
import { type IColumn } from 'shared/ui/TableNew'
import { type EnumUserRoles } from 'entities/Users/model/types'
import { type RowInviteCandidate } from 'entities/Users/model/Table/RowInviteCandidate'
import { useAddMembersContext } from 'pages/settings/pages/members/pages/addMembers/context/addMembersContext'
import { InboxesSelect } from './InboxesSelect/InboxesSelect'
import styles from './styles.module.scss'

const RoleCell = observer(({ row }: { row: RowInviteCandidate }) => {
  const { roleItems, isSendingInvites } = useAddMembersContext()

  const handleRoleChange = (value: EnumUserRoles) => {
    row.setRole(value)
  }

  return (
    <Select
      variant='stroke'
      items={roleItems}
      value={row.role}
      onSelectValue={handleRoleChange}
      disabled={isSendingInvites}
      dropdownProps={{
        withSearch: false,
        propsDropdownList: {
          className: styles.dropdownList,
        },
      }}
    />
  )
})

const InboxesCell = observer(({ row }: { row: RowInviteCandidate }) => {
  const { inboxes, isSendingInvites, isTrial, hideNewInbox } = useAddMembersContext()

  return (
    <InboxesSelect
      row={row}
      inboxes={inboxes}
      disabled={isSendingInvites || isTrial}
      isNewInboxHidden={hideNewInbox}
    />
  )
})

export const getInviteCandidatesColumns = (): IColumn<RowInviteCandidate>[] => [
  {
    field: 'email',
    name: 'Email',
    maxWidth: '240px',
    renderRowCell: (row) => (
      <div className={styles.emailCell}>
        <Avatar info={row.avatarInfo} size={32} fontSize={14} />
        <Typography
          variant='body-md-regular'
          ariaLabel='InviteCandidateEmail'
          tooltipProps={{
            label: row.email,
          }}
          ellipsis
        >
          {row.email}
        </Typography>
      </div>
    ),
  },
  {
    field: 'role',
    name: 'Role',
    width: '120px',
    maxWidth: '120px',
    renderRowCell: (row) => <RoleCell row={row} />,
  },
  {
    field: 'inboxes',
    name: 'Inboxes',
    width: '278px',
    maxWidth: '278px',
    padding: '12px 8px',
    renderRowCell: (row) => <InboxesCell row={row} />,
  },
]
